// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pending__wrapper3CL","text":"pending__textOFB","list":"pending__list1_s","strong":"pending__strong3fj"};